<template>
  <app-modal ref="modal" name="user-profile-modal" :title="title" @before-open="beforeOpen" :is-submitting="isLoading"  @on-ok="onOk">
    <app-form
      ref="form"
      @on-submit="onSubmit"
      :schema="schema"
      :data="formModel"
    />
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/';
import { mapActions } from 'vuex';
import { regexPhoneNumberVN } from '../../utils/regex';

export default {
  name: 'UserProfileModal',
  components: {
    AppModal,
    AppForm,
  },
  data() {
    return {
      title: this.$t('user.updateUserInfo'),
      formModel: {
        name: null,
        phone: null,
        password: null,
      },
      isLoading: false,
      schema: [
        {
          name: 'name',
          label: this.$t('user.name'),
          placeholder: `${this.$t('app.enter')} ${this.$t('user.name')}`,
          type: 'input',
          validation: 'required',
        },
        {
          name: 'phone',
          label: this.$t('user.phone'),
          placeholder: `${this.$t('app.enter')} ${this.$t('user.phone')}`,
          type: 'input',
          validation: { required: true, regex: regexPhoneNumberVN },
        },
        {
          name: 'old_password',
          label: this.$t('user.currentPassword'),
          placeholder: this.$t('user.currentPassword'),
          inputType: 'password',
          type: 'input',
          validation: { min: 6, vietNameChar: true, noWhitespace: true },
        },
        {
          name: 'password',
          label: this.$t('user.password'),
          placeholder: this.$t('user.updateNewPassword'),
          inputType: 'password',
          type: 'input',
          validation: { min: 6, vietNameChar: true, noWhitespace: true },
        },
        {
          name: 're-password',
          label: this.$t('user.repassword'),
          placeholder: this.$t('user.repassword'),
          inputType: 'password',
          type: 'input',
          asyncValidation: (value, resolve, formData) => {
            let result = true;
            if (formData.password && formData.password !== value) {
              result = { msg: this.$t('user.repasswordDoesNotMatch') };
            }
            resolve(result);
          },
        },
      ],
    };
  },
  computed: {},
  methods: {
    ...mapActions('auth', ['updateUserProfile']),
    onSubmit(formModel) {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          this.isLoading = true;
          this.updateUserProfile(formModel).then(() => {
            this.$refs.modal.close();
          }).finally(() => {
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
        }
      });
    },
    onOk() {
      this.$refs.form.submit();
    },
    beforeOpen() {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.formModel.name = currentUser.name;
      this.formModel.phone = currentUser.phone;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/user/user-profile-modal.vue